import { Dispatch } from 'redux'

import type { TUpdateCompanyRequest } from '@homepal/api-contract'

import * as Api from 'redux/api/Companies'

import { useThunkActions } from 'redux/actions/useThunkActions'

import { SnackbarMessage } from 'types/GlobalSnackbar'

import { toggleSnackbarOpen } from '../Snackbar'
import * as actions from './actions'

export function tryGetAllCompanies() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    Api.getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryUpdateCompany(body: TUpdateCompanyRequest) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSaved))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.SettingsSavedFailed))
      })
  }
}

export const useCompanyActions = () => {
  return {
    tryGetAllCompanies: useThunkActions(tryGetAllCompanies),
    tryUpdateCompany: useThunkActions(tryUpdateCompany)
  }
}
